module.exports = __webpack_public_path__ + "img/Avatar.856afcb6.png";